/**
 * AppErrorFallback — static fallback UI for Sentry.ErrorBoundary.
 *
 * CRITICAL: This component must have NO hooks, NO context reads, and NO
 * provider dependencies. ErrorBoundary fallbacks render when the component
 * tree has crashed, meaning provider context may be unmounted.
 */
export function AppErrorFallback() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "#0b1220" }}
    >
      <div className="bg-[#1e293b] border border-[#334155] rounded-lg p-8 max-w-md text-center shadow-lg">
        <h1 className="text-xl font-semibold text-white mb-2">Something went wrong</h1>
        <p className="text-[#94a3b8] mb-6">
          An unexpected error occurred. Please reload the page to continue.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition-colors"
        >
          Reload
        </button>
      </div>
    </div>
  );
}
